module.exports = __webpack_public_path__ + "static/media/welcomeadmin.20e8c98e.png";